import * as moment from "moment";
import { IMenuModel, MenuModel } from "./menu.model";

export interface IModuleModel {
  id?: number;
  name: string;
  application_id: number;
  is_enabled: boolean;
  is_visible: boolean;
  title: string;
  link: string;
  icon: string;
  tooltip: string;
  order_visible: number;
  menus?: IMenuModel[];
  created?: moment.Moment;
  modified?: moment.Moment;
}

export interface IResultModuleModel {
  count: number;
  next: string;
  previous: string;
  results: IModuleModel[];
}

export class ModuleModel {
  id?: number;
  name: string;
  applicationId: number;
  isEnabled: boolean;
  isVisible: boolean;
  title: string;
  link: string;
  icon: string;
  tooltip: string;
  orderVisible: number;
  menus?: MenuModel[] = [];
  created?: moment.Moment;
  modified?: moment.Moment;

  constructor() {
    this.isEnabled = true;
    this.isVisible = true;
    this.orderVisible = 1;
    this.menus = [];
  }

  static fromObject(module: IModuleModel, menuUser: boolean = false): ModuleModel {
    let obj = new ModuleModel();
    obj.id = module.id;
    obj.name = module.name;
    obj.applicationId = module.application_id;
    obj.isEnabled = module.is_enabled;
    obj.isVisible = module.is_visible;
    obj.title = module.title;
    obj.link = module.link;
    obj.icon = module.icon;
    obj.tooltip = module.tooltip;
    obj.orderVisible = module.order_visible;
    obj.created = moment(module.created);
    obj.modified = moment(module.modified);
    obj.menus = (module.menus) ? MenuModel.fromObjectArray(module.menus, menuUser) : [];
    return obj;
  }

  static fromObjectArray(modules: IModuleModel[], menuUser: boolean = false): ModuleModel[] {
    return modules.map((module: IModuleModel) => ModuleModel.fromObject(module, menuUser));
  }
}

export class ResultModuleModel {
  count: number = 0;
  next: string;
  previous: string;
  results: ModuleModel[] = [];

  constructor() {
    this.count = 0;
  }

  static fromObject(result: IResultModuleModel): ResultModuleModel {
    let obj = new ResultModuleModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? ModuleModel.fromObjectArray(result.results) : [];
    return obj;
  }
}

